exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.container[data-v-55e38efb]{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column\n}\n.voltar-container[data-v-55e38efb]{padding:0 20px\n}\n", "", {"version":3,"sources":["/app/frontend/src/screens/ouvidoria/VisualizarConversa.vue"],"names":[],"mappings":";AA8EA,4BACE,4BAAA,6BAAA,0BAAA,qBAAsB;CACvB;AAAA,mCAEC,cAAe;CAChB","file":"VisualizarConversa.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.container {\n  flex-direction: column;\n}\n.voltar-container {\n  padding: 0 20px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-55e38efb","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/screens/ouvidoria/VisualizarConversa.vue
// module id = q9mF
// module chunks = 11